import React, { ReactNode } from 'react';

import * as styles from './listing-page-row-layout.scss';

interface ListingPageRowLayoutProps {
  nameColumn: ReactNode;
  metrics: ReactNode;
  actions: ReactNode;
  className?: string;
  nameColumnFlexBasis?: number;
}

export const ListingPageRowLayout = ({
  nameColumn,
  metrics,
  actions,
  className,
  nameColumnFlexBasis
}: ListingPageRowLayoutProps) => (
  <div className={`${styles.row}${className ? ` ${className}` : ''}`} role="row">
    <div
      className={styles.nameColumn}
      role="cell"
      style={nameColumnFlexBasis === undefined ? undefined : { flexBasis: `${nameColumnFlexBasis}px` }}
    >
      {nameColumn}
    </div>

    <div className={styles.metricsRow} role="presentation">
      {metrics}
    </div>

    <div className={styles.actionsColumn} role="cell">
      {actions}
    </div>
  </div>
);
